<template>
  <div
    class="spinner"
    :class="{ small, tiny, 'p-3': !tiny, 'shadow-1': !tiny }"
    v-html="svg"></div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import svg from "@/app/assets/images/marque-circle.svg?raw";

export default {
  name: "LoadingSpinner",
  props: {
    small: {
      type: Boolean,
      default: false
    },
    tiny: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svg
    };
  }
};
</script>

<style scoped>
.small {
  transform-origin: center center;
  transform: scale(0.8);
}

.tiny {
  transform-origin: center center;
  transform: scale(0.4);
}
</style>
